export default __webpack_public_path__ + "static/media/reminder-big.73821fd6.svg";